import type { ProductType } from '@data-access/graphql/schema.types'

export function getWishlistTrackingItemId(id: number, type: ProductType): string {
  switch (type) {
    case 'experience':
      return `E-${id}`
    case 'accommodation':
      return `A-${id}`
    case 'beach_chair':
      return `S-${id}`
    case 'bike':
      return `R-${id}`
    default:
      return 'unknown'
  }
}
